import { useEffect } from 'react'

export const MapInitialiserWithVehicle = (location, mapRef) => {

     useEffect(() => {
        if (!mapRef) return

        const { lat, lon } = location || {}

        if (lat && lon) {
            mapRef.panTo({ lat: lat, lng: lon })
            mapRef.setZoom(18)
        }
    }, [mapRef, location])

}